import { Search100 } from '@at/track-types'

export const searchEntity = (searchId: string, pageNumber: number): Search100 => ({
    SCHEMA_KEY: 'Search100',
    search_id: searchId,
    page_number: pageNumber,
})
